import {
  KProperty02ce7r476m8633 as KProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UtcOffset2q1jzx5thduw7 as UtcOffset,
  UtcOffset17lxgyhnn4rny as UtcOffset_0,
} from '../UtcOffset.mjs';
import { abs1kdzbjes1idip as abs } from '../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { UnsignedIntFieldFormatDirective20kfpdbszyixg as UnsignedIntFieldFormatDirective } from '../internal/format/FieldFormatDirective.mjs';
import {
  Padding_ZERO_getInstance2hdjif6phlc74 as Padding_ZERO_getInstance,
  Padding_SPACE_getInstance7fwkzb4da6c as Padding_SPACE_getInstance,
  AbstractDateTimeFormat1er9ki1vjeb1b as AbstractDateTimeFormat,
} from './DateTimeFormat.mjs';
import { AppendableFormatStructure38mt32f1b8qva as AppendableFormatStructure } from '../internal/format/Builder.mjs';
import {
  appendAlternativeParsingImpl1mug8j87kp2j3 as appendAlternativeParsingImpl,
  appendOptionalImplcg29ds00y54b as appendOptionalImpl,
  chars1g48a4lypizqb as chars,
  build284bs2tzkjm2x as build,
  offsetHours$default2ltn8vk6i6a0z as offsetHours$default,
  offsetMinutesOfHour$defaultx23z50nh5v5p as offsetMinutesOfHour$default,
  offsetSecondsOfMinute$defaultxai9ucsyqlc7 as offsetSecondsOfMinute$default,
  AbstractDateTimeFormatBuilder2kkelk07l4wb as AbstractDateTimeFormatBuilder,
  WithUtcOffset30ws1ntcash0j as WithUtcOffset,
  alternativeParsing1gmwubnsvpp9b as alternativeParsing,
  optional3j6ywsx1pxeh6 as optional,
  char1r4ssccmdfesy as char,
} from './DateTimeFormatBuilder.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  PropertyAccessor1m9zk65ebkfc4 as PropertyAccessor,
  UnsignedFieldSpec1pqzij1hidkca as UnsignedFieldSpec,
} from '../internal/format/FieldSpec.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  BasicFormatStructure1rp1tyv3u2fjw as BasicFormatStructure,
  SignedFormatStructure3e3cmtnnik1yf as SignedFormatStructure,
} from '../internal/format/FormatStructure.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_ISO_OFFSET() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp0 = ISO_OFFSET$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_OFFSET', 0, tmp, _get_ISO_OFFSET_$ref_70d0nn(), null);
  return tmp0.f2();
}
var ISO_OFFSET$delegate;
function get_ISO_OFFSET_BASIC() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp0 = ISO_OFFSET_BASIC$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_OFFSET_BASIC', 0, tmp, _get_ISO_OFFSET_BASIC_$ref_lasmde(), null);
  return tmp0.f2();
}
var ISO_OFFSET_BASIC$delegate;
function get_FOUR_DIGIT_OFFSET() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp0 = FOUR_DIGIT_OFFSET$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('FOUR_DIGIT_OFFSET', 0, tmp, _get_FOUR_DIGIT_OFFSET_$ref_30p6v2(), null);
  return tmp0.f2();
}
var FOUR_DIGIT_OFFSET$delegate;
function get_emptyIncompleteUtcOffset() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  return emptyIncompleteUtcOffset;
}
var emptyIncompleteUtcOffset;
var UtcOffsetFieldContainerClass;
function UtcOffsetFieldContainer() {
  if (UtcOffsetFieldContainerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'UtcOffsetFieldContainer');
    UtcOffsetFieldContainerClass = $;
  }
  return UtcOffsetFieldContainerClass;
}
var IncompleteUtcOffsetClass;
function IncompleteUtcOffset() {
  if (IncompleteUtcOffsetClass === VOID) {
    class $ {
      constructor(isNegative, totalHoursAbs, minutesOfHour, secondsOfMinute) {
        isNegative = isNegative === VOID ? null : isNegative;
        totalHoursAbs = totalHoursAbs === VOID ? null : totalHoursAbs;
        minutesOfHour = minutesOfHour === VOID ? null : minutesOfHour;
        secondsOfMinute = secondsOfMinute === VOID ? null : secondsOfMinute;
        this.i1q_1 = isNegative;
        this.j1q_1 = totalHoursAbs;
        this.k1q_1 = minutesOfHour;
        this.l1q_1 = secondsOfMinute;
      }
      h1q(_set____db54di) {
        this.i1q_1 = _set____db54di;
      }
      m1q() {
        return this.i1q_1;
      }
      r1q(_set____db54di) {
        this.j1q_1 = _set____db54di;
      }
      s1q() {
        return this.j1q_1;
      }
      n1q(_set____db54di) {
        this.k1q_1 = _set____db54di;
      }
      o1q() {
        return this.k1q_1;
      }
      p1q(_set____db54di) {
        this.l1q_1 = _set____db54di;
      }
      q1q() {
        return this.l1q_1;
      }
      d1s() {
        var sign = this.i1q_1 === true ? -1 : 1;
        var tmp0_safe_receiver = this.j1q_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = imul(tmp0_safe_receiver, sign);
        }
        var tmp_0 = tmp;
        var tmp1_safe_receiver = this.k1q_1;
        var tmp_1;
        if (tmp1_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_1 = imul(tmp1_safe_receiver, sign);
        }
        var tmp_2 = tmp_1;
        var tmp2_safe_receiver = this.l1q_1;
        var tmp_3;
        if (tmp2_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_3 = imul(tmp2_safe_receiver, sign);
        }
        return UtcOffset(tmp_0, tmp_2, tmp_3);
      }
      e1z(offset) {
        this.i1q_1 = offset.k1s() < 0;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = offset.k1s();
        var totalSecondsAbs = abs(this_0);
        this.j1q_1 = totalSecondsAbs / 3600 | 0;
        this.k1q_1 = (totalSecondsAbs / 60 | 0) % 60 | 0;
        this.l1q_1 = totalSecondsAbs % 60 | 0;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        var tmp_2;
        if (other instanceof IncompleteUtcOffset()) {
          tmp_2 = this.i1q_1 == other.i1q_1;
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp_1 = this.j1q_1 == other.j1q_1;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.k1q_1 == other.k1q_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.l1q_1 == other.l1q_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.i1q_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_0 = this.j1q_1;
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
        var tmp_0 = tmp + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_1 = this.k1q_1;
        var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
        var tmp_1 = tmp_0 + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_2 = this.l1q_1;
        var tmp1_elvis_lhs_2 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
        return tmp_1 + (tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2) | 0;
      }
      t1q() {
        return new (IncompleteUtcOffset())(this.i1q_1, this.j1q_1, this.k1q_1, this.l1q_1);
      }
      toString() {
        var tmp0_safe_receiver = this.i1q_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = tmp0_safe_receiver ? '-' : '+';
        }
        var tmp1_elvis_lhs = tmp;
        var tmp_0 = tmp1_elvis_lhs == null ? ' ' : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = this.j1q_1;
        var tmp_1 = toString(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
        var tmp3_elvis_lhs = this.k1q_1;
        var tmp_2 = toString(tmp3_elvis_lhs == null ? '??' : tmp3_elvis_lhs);
        var tmp4_elvis_lhs = this.l1q_1;
        return tmp_0 + tmp_1 + ':' + tmp_2 + ':' + toString(tmp4_elvis_lhs == null ? '??' : tmp4_elvis_lhs);
      }
    }
    initMetadataForClass($, 'IncompleteUtcOffset', IncompleteUtcOffset, VOID, [UtcOffsetFieldContainer()]);
    IncompleteUtcOffsetClass = $;
  }
  return IncompleteUtcOffsetClass;
}
var UtcOffsetWholeHoursDirectiveClass;
function UtcOffsetWholeHoursDirective() {
  if (UtcOffsetWholeHoursDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = OffsetFields_getInstance().g1z_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.n1z_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof UtcOffsetWholeHoursDirective()) {
          tmp = this.n1z_1.equals(other.n1z_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.n1z_1.hashCode();
      }
    }
    initMetadataForClass($, 'UtcOffsetWholeHoursDirective');
    UtcOffsetWholeHoursDirectiveClass = $;
  }
  return UtcOffsetWholeHoursDirectiveClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      o1z(block) {
        var builder = new (Builder())(new (AppendableFormatStructure())());
        block(builder);
        return new (UtcOffsetFormat())(builder.m1r());
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(actualBuilder) {
        this.p1z_1 = actualBuilder;
      }
      o1s() {
        return this.p1z_1;
      }
      s1s(structure) {
        this.p1z_1.r1s(structure);
      }
      t1s() {
        return new (Builder())(new (AppendableFormatStructure())());
      }
    }
    protoOf($).u1s = appendAlternativeParsingImpl;
    protoOf($).v1s = appendOptionalImpl;
    protoOf($).g1r = chars;
    protoOf($).m1r = build;
    protoOf($).i1t = offsetHours;
    protoOf($).z1q = offsetHours$default;
    protoOf($).j1t = offsetMinutesOfHour;
    protoOf($).k1t = offsetMinutesOfHour$default;
    protoOf($).l1t = offsetSecondsOfMinute;
    protoOf($).m1t = offsetSecondsOfMinute$default;
    protoOf($).a1r = offset;
    initMetadataForClass($, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder(), AbstractWithOffsetBuilder()]);
    BuilderClass = $;
  }
  return BuilderClass;
}
var UtcOffsetFormatClass;
function UtcOffsetFormat() {
  if (UtcOffsetFormatClass === VOID) {
    class $ extends AbstractDateTimeFormat() {
      constructor(actualFormat) {
        super();
        this.q1z_1 = actualFormat;
      }
      o1t() {
        return this.q1z_1;
      }
      r1z(value) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (IncompleteUtcOffset())();
        this_0.e1z(value);
        return this_0;
      }
      q1t(value) {
        return this.r1z(value instanceof UtcOffset_0() ? value : THROW_CCE());
      }
      s1z(intermediate) {
        return intermediate.d1s();
      }
      s1t(intermediate) {
        return this.s1z(intermediate instanceof IncompleteUtcOffset() ? intermediate : THROW_CCE());
      }
      t1t() {
        return get_emptyIncompleteUtcOffset();
      }
    }
    initMetadataForClass($, 'UtcOffsetFormat');
    UtcOffsetFormatClass = $;
  }
  return UtcOffsetFormatClass;
}
function UtcOffsetFieldContainer$_get_isNegative_$ref_77h81t() {
  return (p0) => p0.m1q();
}
function UtcOffsetFieldContainer$_set_isNegative_$ref_ibm7zn() {
  return (p0, p1) => {
    p0.h1q(p1);
    return Unit_instance;
  };
}
var OffsetFields$sign$1Class;
function OffsetFields$sign$1() {
  if (OffsetFields$sign$1Class === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        var tmp_0 = KMutableProperty1();
        var tmp_1 = UtcOffsetFieldContainer$_get_isNegative_$ref_77h81t();
        tmp.t1z_1 = new (PropertyAccessor())(getPropertyCallableRef('isNegative', 1, tmp_0, tmp_1, UtcOffsetFieldContainer$_set_isNegative_$ref_ibm7zn()));
      }
      m1q() {
        return this.t1z_1;
      }
      u1z(obj) {
        var tmp;
        var tmp_0;
        var tmp0_elvis_lhs = obj.s1q();
        if ((tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) === 0) {
          var tmp1_elvis_lhs = obj.o1q();
          tmp_0 = (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) === 0;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          var tmp2_elvis_lhs = obj.q1q();
          tmp = (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) === 0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      v1z(obj) {
        return this.u1z((!(obj == null) ? isInterface(obj, UtcOffsetFieldContainer()) : false) ? obj : THROW_CCE());
      }
    }
    initMetadataForClass($);
    OffsetFields$sign$1Class = $;
  }
  return OffsetFields$sign$1Class;
}
function UtcOffsetFieldContainer$_get_totalHoursAbs_$ref_y3gcjx() {
  return (p0) => p0.s1q();
}
function UtcOffsetFieldContainer$_set_totalHoursAbs_$ref_cdng9l() {
  return (p0, p1) => {
    p0.r1q(p1);
    return Unit_instance;
  };
}
function UtcOffsetFieldContainer$_get_minutesOfHour_$ref_maulc0() {
  return (p0) => p0.o1q();
}
function UtcOffsetFieldContainer$_set_minutesOfHour_$ref_r0gkcs() {
  return (p0, p1) => {
    p0.n1q(p1);
    return Unit_instance;
  };
}
function UtcOffsetFieldContainer$_get_secondsOfMinute_$ref_7vltlc() {
  return (p0) => p0.q1q();
}
function UtcOffsetFieldContainer$_set_secondsOfMinute_$ref_l6c2ho() {
  return (p0, p1) => {
    p0.p1q(p1);
    return Unit_instance;
  };
}
var OffsetFieldsClass;
function OffsetFields() {
  if (OffsetFieldsClass === VOID) {
    class $ {
      constructor() {
        OffsetFields_instance = this;
        var tmp = this;
        tmp.f1z_1 = new (OffsetFields$sign$1())();
        var tmp_0 = this;
        var tmp_1 = KMutableProperty1();
        var tmp_2 = UtcOffsetFieldContainer$_get_totalHoursAbs_$ref_y3gcjx();
        var tmp0_accessor = new (PropertyAccessor())(getPropertyCallableRef('totalHoursAbs', 1, tmp_1, tmp_2, UtcOffsetFieldContainer$_set_totalHoursAbs_$ref_cdng9l()));
        var tmp1_sign = this.f1z_1;
        tmp_0.g1z_1 = new (UnsignedFieldSpec())(tmp0_accessor, 0, 18, VOID, 0, tmp1_sign);
        var tmp_3 = this;
        var tmp_4 = KMutableProperty1();
        var tmp_5 = UtcOffsetFieldContainer$_get_minutesOfHour_$ref_maulc0();
        var tmp0_accessor_0 = new (PropertyAccessor())(getPropertyCallableRef('minutesOfHour', 1, tmp_4, tmp_5, UtcOffsetFieldContainer$_set_minutesOfHour_$ref_r0gkcs()));
        var tmp1_sign_0 = this.f1z_1;
        tmp_3.h1z_1 = new (UnsignedFieldSpec())(tmp0_accessor_0, 0, 59, VOID, 0, tmp1_sign_0);
        var tmp_6 = this;
        var tmp_7 = KMutableProperty1();
        var tmp_8 = UtcOffsetFieldContainer$_get_secondsOfMinute_$ref_7vltlc();
        var tmp0_accessor_1 = new (PropertyAccessor())(getPropertyCallableRef('secondsOfMinute', 1, tmp_7, tmp_8, UtcOffsetFieldContainer$_set_secondsOfMinute_$ref_l6c2ho()));
        var tmp1_sign_1 = this.f1z_1;
        tmp_6.i1z_1 = new (UnsignedFieldSpec())(tmp0_accessor_1, 0, 59, VOID, 0, tmp1_sign_1);
      }
    }
    initMetadataForObject($, 'OffsetFields');
    OffsetFieldsClass = $;
  }
  return OffsetFieldsClass;
}
var OffsetFields_instance;
function OffsetFields_getInstance() {
  if (OffsetFields_instance === VOID)
    new (OffsetFields())();
  return OffsetFields_instance;
}
function offsetHours(padding) {
  return this.s1s(new (SignedFormatStructure())(new (BasicFormatStructure())(new (UtcOffsetWholeHoursDirective())(padding)), true));
}
function offsetMinutesOfHour(padding) {
  return this.s1s(new (BasicFormatStructure())(new (UtcOffsetMinuteOfHourDirective())(padding)));
}
function offsetSecondsOfMinute(padding) {
  return this.s1s(new (BasicFormatStructure())(new (UtcOffsetSecondOfMinuteDirective())(padding)));
}
function offset(format) {
  var tmp;
  if (format instanceof UtcOffsetFormat()) {
    this.s1s(format.q1z_1);
    tmp = Unit_instance;
  }
  return tmp;
}
var AbstractWithOffsetBuilderClass;
function AbstractWithOffsetBuilder() {
  if (AbstractWithOffsetBuilderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'AbstractWithOffsetBuilder', VOID, VOID, [WithUtcOffset()]);
    AbstractWithOffsetBuilderClass = $;
  }
  return AbstractWithOffsetBuilderClass;
}
var UtcOffsetMinuteOfHourDirectiveClass;
function UtcOffsetMinuteOfHourDirective() {
  if (UtcOffsetMinuteOfHourDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = OffsetFields_getInstance().h1z_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.a20_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof UtcOffsetMinuteOfHourDirective()) {
          tmp = this.a20_1.equals(other.a20_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.a20_1.hashCode();
      }
    }
    initMetadataForClass($, 'UtcOffsetMinuteOfHourDirective');
    UtcOffsetMinuteOfHourDirectiveClass = $;
  }
  return UtcOffsetMinuteOfHourDirectiveClass;
}
var UtcOffsetSecondOfMinuteDirectiveClass;
function UtcOffsetSecondOfMinuteDirective() {
  if (UtcOffsetSecondOfMinuteDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = OffsetFields_getInstance().i1z_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.f20_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof UtcOffsetSecondOfMinuteDirective()) {
          tmp = this.f20_1.equals(other.f20_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.f20_1.hashCode();
      }
    }
    initMetadataForClass($, 'UtcOffsetSecondOfMinuteDirective');
    UtcOffsetSecondOfMinuteDirectiveClass = $;
  }
  return UtcOffsetSecondOfMinuteDirectiveClass;
}
function ISO_OFFSET$delegate$lambda() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = Companion_instance;
  return tmp.o1z(ISO_OFFSET$delegate$lambda$lambda);
}
function ISO_OFFSET$delegate$lambda$lambda($this$build) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = [ISO_OFFSET$delegate$lambda$lambda$lambda];
  alternativeParsing($this$build, tmp, ISO_OFFSET$delegate$lambda$lambda$lambda_0);
  return Unit_instance;
}
function ISO_OFFSET$delegate$lambda$lambda$lambda($this$alternativeParsing) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$alternativeParsing.g1r('z');
  return Unit_instance;
}
function ISO_OFFSET$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  optional($this$alternativeParsing, 'Z', ISO_OFFSET$delegate$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET$delegate$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$optional.z1q();
  char($this$optional, _Char___init__impl__6a9atx(58));
  $this$optional.k1t();
  optional($this$optional, VOID, ISO_OFFSET$delegate$lambda$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET$delegate$lambda$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  char($this$optional, _Char___init__impl__6a9atx(58));
  $this$optional.m1t();
  return Unit_instance;
}
function _get_ISO_OFFSET_$ref_70d0nn() {
  return () => get_ISO_OFFSET();
}
function ISO_OFFSET_BASIC$delegate$lambda() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = Companion_instance;
  return tmp.o1z(ISO_OFFSET_BASIC$delegate$lambda$lambda);
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda($this$build) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = [ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda];
  alternativeParsing($this$build, tmp, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda_0);
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda($this$alternativeParsing) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$alternativeParsing.g1r('z');
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  optional($this$alternativeParsing, 'Z', ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$optional.z1q();
  optional($this$optional, VOID, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$optional.k1t();
  optional($this$optional, VOID, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$optional.m1t();
  return Unit_instance;
}
function _get_ISO_OFFSET_BASIC_$ref_lasmde() {
  return () => get_ISO_OFFSET_BASIC();
}
function FOUR_DIGIT_OFFSET$delegate$lambda() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = Companion_instance;
  return tmp.o1z(FOUR_DIGIT_OFFSET$delegate$lambda$lambda);
}
function FOUR_DIGIT_OFFSET$delegate$lambda$lambda($this$build) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$build.z1q();
  $this$build.k1t();
  return Unit_instance;
}
function _get_FOUR_DIGIT_OFFSET_$ref_30p6v2() {
  return () => get_FOUR_DIGIT_OFFSET();
}
var properties_initialized_UtcOffsetFormat_kt_6y9jku;
function _init_properties_UtcOffsetFormat_kt__9r9ddw() {
  if (!properties_initialized_UtcOffsetFormat_kt_6y9jku) {
    properties_initialized_UtcOffsetFormat_kt_6y9jku = true;
    ISO_OFFSET$delegate = lazy(ISO_OFFSET$delegate$lambda);
    ISO_OFFSET_BASIC$delegate = lazy(ISO_OFFSET_BASIC$delegate$lambda);
    FOUR_DIGIT_OFFSET$delegate = lazy(FOUR_DIGIT_OFFSET$delegate$lambda);
    emptyIncompleteUtcOffset = new (IncompleteUtcOffset())();
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  offsetHours as offsetHours2ainakfaneygi,
  offsetMinutesOfHour as offsetMinutesOfHour39hwa562rk4r3,
  offsetSecondsOfMinute as offsetSecondsOfMinute2h4jaqdr0ywca,
  offset as offset2sn0i35letyt2,
  AbstractWithOffsetBuilder as AbstractWithOffsetBuilder1whsl6o4h46l,
  get_FOUR_DIGIT_OFFSET as get_FOUR_DIGIT_OFFSET2nvpbkfa3o459,
  get_ISO_OFFSET as get_ISO_OFFSET1wt81dckmqhlf,
  get_ISO_OFFSET_BASIC as get_ISO_OFFSET_BASICumnsw87b3jry,
  IncompleteUtcOffset as IncompleteUtcOffset2j7l7xiralfth,
  UtcOffsetFieldContainer as UtcOffsetFieldContainer34kiua261u8tn,
};
//endregion

//# sourceMappingURL=UtcOffsetFormat.mjs.map
